import { Label } from "reactstrap";
import { formatDate, formatRP } from "../../Utils/externalFunctions";

const VisualizationAttr = ({ label, content, isCurrency, isDate }) => {
  const checkIsArray = (content) => {
    return content instanceof Array;
  };

  return (
    <div className="mb-2">
      <Label>
        <span>{label?.toUpperCase()}</span>
      </Label>
      {content ? (
        isCurrency ? (
          <div>{`Rp. ${formatRP(content)}`}</div>
        ) : isDate ? (
          <div>{formatDate(content)}</div>
        ) : checkIsArray(content) ? (
          <div>{content.join(", ")}</div>
        ) : (
          <div>{content}</div>
        )
      ) : (
        <div>-</div>
      )}
    </div>
  );
};

export default VisualizationAttr;
